import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuJap = () => {
  const [isOpen, setIsOpen] = useState(false)
          
  const toggle = () => {
  setIsOpen(!isOpen)
  }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                                SUSHI & SASHIMI. 
                            </div><br /><br />
                            <div className='menu_mat'>
                                Lax nigiri med wasabi.
                                <br /><br />
                                Ebi nigiri – räkor.
                                <br /><br />
                                California maki med krabba, avokado & gurka.
                                <br /><br />
                                Spicy salmon maki med lax, chili & sesam.
                                <br /><br />
                                Avokado maki.
                                <br /><br />
                                Lax sashimi med ponzu & sesam.
                                <br /><br />
                                Ingefära, wasabi & japansk soja.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                KALLA JAPANSKA DELIKATESSER
                              </div><br /><br />
                              <div className='menu_mat'>
                                Wakame-sallad med sesam.
                                <br /><br />
                                Edamame med havssalt.
                                <br /><br />
                                Gurksallad med risvinäger, sesam & chili.
                                <br /><br />
                                Kallmarinerad lax med ponzu.
                                <br /><br />
                                Kålsallad med japansk sesamdressing.
                                <br /><br />
                                Picklad rättika, ingefära & gurka.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA JAPANSKA SPECIALITETER
                              </div><br /><br />
                            <div className='menu_mat'>
                                Teriyaki-kyckling med sesam & salladslök.
                                <br /><br />
                                Yakitori – marinerade kycklingspett med teriyakisås.
                                <br /><br />
                                Crispy chicken med japansk chilimajonnäs.
                                <br /><br />
                                Gyoza – japanska dumplings med kyckling & grönsaker.
                                <br /><br />
                                Panko-friterade räkor med chilimajonnäs.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              JAPANSKA TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Japanskt ångat ris.
                                    <br /><br />
                                    Yakimeshi – japanskt stekt ris med grönsaker & ägg.
                                    <br /><br />
                                    Wokade grönsaker med ingefära & soja.
                                    <br /><br />
                                    Sesammarinerad broccoli.
                                    <br /><br />
                                    Japansk ponzusås.
                                    <br /><br />
                                    Teriyakisås.
                                    <br /><br />
                                    Spicy mayo.
                                </div>
                                </div>
                                <div className='card'>
                                <div className='meny_title'>
                                   JAPANSKA SALLADER
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Kålsallad med sesam & japansk vinägrett.
                                    <br /><br />
                                    Sobanudelsallad med grönsaker & sesam.
                                    <br /><br />
                                    Gurka, wakame & ponzu.
                                    <br /><br />
                                    Morot & rättika med ingefära.
                                    <br /><br />
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                JAPANSKA DESSERTER
                            </div><br /><br />
                        <div className='menu_mat'>
                            Matcha cheesecake.
                            <br /><br />
                            Mochi med olika smaker.
                            <br /><br />
                            Yuzu-pannacotta.
                            <br /><br />
                            Sesam- & matchakakor.
                            <br /><br />
                            Färsk ananas & melon.
                            <br /><br />
                        </div>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuJap